import React from "react"
import { makeStyles, Theme, Grid, Typography } from "@material-ui/core"
import LockIcon from "@material-ui/icons/Lock";

const useStyles = makeStyles((theme: Theme) => ({
	lockIconGrid: {
		[theme.breakpoints.down("sm")]: {
			paddingBottom: "0px !important"
		}
	},
	lockIcon: {
		height: 60,
		[theme.breakpoints.down("sm")]: {
			height: 48
		}
	},
	subtitleGrid: {
		paddingTop: "4px !important",
		marginBottom: 24
	},
	subtitle: {
		fontWeight: "bold",
		[theme.breakpoints.down("xs")]: {
			lineHeight: 1.3
		}
	},
}));

export const OnboardingHeader = ({subtitle, isMobile}: {subtitle: string, isMobile: boolean}) => {

	const classes = useStyles();

	return (
		<>
			<Grid item xs={12} className={classes.lockIconGrid}>
				<Typography
					component="h1"
					variant={isMobile ? "h3" : "h2"}
					align="center"
					className={classes.lockIcon}
				>
					<LockIcon fontSize="inherit" />
				</Typography>
			</Grid>
			<Grid item xs={12} className={classes.subtitleGrid}>
				<Typography
					component="h1"
					variant={isMobile ? "h6" : "h4"}
					className={classes.subtitle}
					align="center"
				>
						{subtitle}
				</Typography>
			</Grid>
		</>
	);
}
